import { Amplify } from 'aws-amplify';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { myAmplifyConfig } from './shared/components/auth/amplify-config';

Amplify.configure(myAmplifyConfig);

const container = document.getElementById('root') as HTMLElement;

createRoot(container).render(<App />);
